// extracted by mini-css-extract-plugin
export var container = "CatalogFormModal-module--container--2bHG1";
export var closeButton = "CatalogFormModal-module--closeButton--2rN4o";
export var title = "CatalogFormModal-module--title--2Y1E7";
export var description = "CatalogFormModal-module--description--1m8fI";
export var tabs = "CatalogFormModal-module--tabs--1TPiX";
export var pane = "CatalogFormModal-module--pane--CpoXf";
export var activePane = "CatalogFormModal-module--activePane--3TOeM";